import React from 'react';
import { Button, message, Tooltip } from 'antd';
import { useAppState } from 'context';
import { ReactComponent as ShareSvg } from 'assets/share-link.svg';
import { CreativeType, DisplayBannerT } from "types/creative";
import { CREATIVE_PARAMS_BANNER, CREATIVE_PARAMS_PLAYER_SIZE } from 'services/constants';
import config from 'config';

import './ShareIcon.scss';

const ENV = config.hostEnv;

const getCreativeParamsBanner = (width: number = 300, height: number = 250) => {
  const bannerParam = Object.entries(CREATIVE_PARAMS_BANNER).find(
    ([key, val], idx) => idx !== 0 && val.size.width === width && val.size.height === height
  );
  return bannerParam ? bannerParam[0] : 0; // default to not active and 300x250
};

// const getCreativeParamsPlayerSize = (size: string = 'md') => {
//   const sizeParam = Object.entries(CREATIVE_PARAMS_PLAYER_SIZE).find(([key, val]) => val === size);
//   return sizeParam ? sizeParam[0] : 2; // default to medium
// };

const buildShareLink = () => {
  const envUrls = {
    development: `http://localhost:3002/share/`,
    staging: `https://api-stg.radius.video/previews/share/`,
    qa: `https://qa.radius.video/previews/share/`,
    production: `https://radius.video/previews/share/`,
  };
  return envUrls[ENV];
};

const genericCopyToClipboard = (content) => {
  const textArea = document.createElement('textarea');
  textArea.value = content;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    const successful = document.execCommand('copy');
    const msg = successful ? 'Shareable link successfully copied' : 'Unable to copy to clipboard';
    message.success(msg);
  } catch (err) {
    message.error('Unable to copy to clipboard');
  }
  document.body.removeChild(textArea);
};

const ShareIcon = () => {
  const {
    mobileView,
    creative: { id } = {} as CreativeType,
    activeCreativeView: { width, height } = {} as any,
    displayBanner: { active: bannerActive, size } = {} as DisplayBannerT,
    sizeViewList = [],
  } = useAppState();  
  // set the params for the shareable link based on the current state of the app
  // format must be in order: id, banner, player, mobile
  const defineQueryStringParams = () => {
    const banner = bannerActive ? getCreativeParamsBanner(size?.width, size?.height) : '0';
    const player = sizeViewList.findIndex(({size}) => size.width === width && size.height === height);
    const mobile = mobileView ? '1' : '0';
    return [
      id, banner, player, mobile,
    ];
  }

  const handleClick = () => {
    const params = defineQueryStringParams().toString();
    const encodedPortion = encodeURIComponent(btoa(`${params}`));
    const url = `${buildShareLink()}${encodedPortion}`;
    genericCopyToClipboard(url);
  }
  return (
    <Tooltip title='Shareable Link'>
      <Button type='primary' 
        shape='circle' 
        className='app-icon-container' 
        onClick={handleClick} 
      >
        <ShareSvg fill={'#999b9e'} />
      </Button>
    </Tooltip>
  );
}

export default ShareIcon;
